module.exports = __webpack_public_path__ + "img/icon-home-1.bca1ba4a.svg";